import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Progress Bar after logo
 * TODO , this element in work
 */
const ProgressBarContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    '&>div:first-of-type,&>div:first-of-type>div': {
        textAlign: 'left',
    },
    '&>div:last-of-type,&>div:last-of-type>div': {
        textAlign: 'right',
    },
}));

const StepContainer = styled(Box)(({ theme, isactiveprop }) => ({
    position: 'relative',
    flex: '1',
    textAlign: 'center',
    // color: isactiveprop === 'true' ? '#12cac9' : '#f1f1f1',
    color: '#f1f1f1',
    '& span': {
        position: 'relative',
        display: 'inline-flex',
        background: '#161938',
        borderRadius: '50%'
    },
    '& i': {
        position: 'relative',
    },
    '& svg': {
        position: 'relative',
        zIndex: 2
    },
}));

const Label = styled(Box)(({ theme }) => ({
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: 1.57,
    '@media (max-width: 400px)': {
        fontSize: '12px',
    },
    '@media (min-width: 600px)': {
        br: {
            display: 'none',
        },
    },
}));



export const RegProgressBar = ({ view, currentStep, isSocialLogin }) => {
    let stepLabels = null;
    if (currentStep >= 3) {
        let newStep = currentStep - 2;

        if (isSocialLogin == true) { // for OAuth
            if (view === 'creator') {
                stepLabels = {
                    1: 'Confirm <br/>Details',
                    2: 'Complete <br/>Profile',
                    3: 'Create <br/>Circle',
                };
            } else if (view === 'fan') {
                newStep = currentStep - 1;
                stepLabels = {
                    1: 'Login <br/>Method',
                    2: 'Confirm <br/>Details',
                    3: 'Complete <br/>Profile'
                };
            }
        } else { //without OAuth
            if (view === 'creator') {
                stepLabels = {
                    1: 'Add <br/>Details',
                    2: 'Complete <br/>Profile',
                    3: 'Create <br/>Circle',
                    4: 'Confirm <br/>Email'
                };
            } else if (view === 'fan') {
                stepLabels = {
                    1: 'Add <br/>Details',
                    2: 'Complete <br/>Profile',
                    3: 'Confirm <br/>Email'
                };
            }
        }
        const labelsCount = Object.keys(stepLabels).length;
        if (stepLabels) {
            const renderSteps = () => {
                return Object.keys(stepLabels).map((stepNumber, index) => {
                    const isActiveStep = parseInt(stepNumber) === newStep;
                    const isPreviousStep = parseInt(stepNumber) < newStep;

                    return (
                        <StepContainer
                            className='circles-row-item'
                            key={stepNumber}
                            style={{ zIndex: (index + 1) }}
                            ispreviousstep={isPreviousStep ? 'true' : 'false'}
                            isactiveprop={isActiveStep ? 'true' : 'false'}
                        >
                            {isPreviousStep && (
                                <span className='circles-row-icon'>
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="13" cy="13" r="13" fill="#8140B7" />
                                        <path d="M6.93353 13L10.8335 16.9L18.2002 9.53333" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            )
                            }
                            {!isPreviousStep && (
                                <span className='circles-row-icon'>
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="13" cy="13" r="12" stroke={isActiveStep ? '#8140B7' : '#5A4F7A'} strokeWidth="2" />
                                        {isActiveStep && <circle cx="13" cy="13" r="3" fill="#8140B7" />}
                                    </svg>
                                </span>
                            )}
                            <Label
                                className='circles-row-name'
                                dangerouslySetInnerHTML={{ __html: stepLabels[stepNumber] }}
                            />
                        </StepContainer >
                    );
                });
            };

            return (
                <ProgressBarContainer className={`circles-row circles-row-${labelsCount}`}>
                    {renderSteps()}
                </ProgressBarContainer>

            );
        }
    }
};